import { FeatureFlag } from '@/constants/featureFlags';
import { countriesExcludedFromDefaultSaveCardBox } from '@/constants/excludedCountries';
import type { Customer } from '@/types/checkout';
import type { AddressDetails } from '@/types/context';
import { isCaliforniaState } from '@/utils/tax';

interface CheckSavedCardBoxParams {
  customer?: Customer;
  addressDetails?: AddressDetails;
  featureFlags?: Record<FeatureFlag, boolean>;
}

export function getAllowDefaultCheckSavedCardBox({ customer, addressDetails, featureFlags }: CheckSavedCardBoxParams): {
  isDefaultSaveCardAllowedForLocation: boolean;
} {
  const countryCode2 = (customer?.taxCountry || customer?.geoLocator?.countryCode2 || '').toUpperCase();

  const state = addressDetails?.state || customer?.address?.state || customer?.geoLocator?.state;
  const isCalifornia = Boolean(state) && isCaliforniaState(String(state).toUpperCase());

  const isDefaultSaveCardAllowedForLocation =
    !countriesExcludedFromDefaultSaveCardBox.has(countryCode2) && !isCalifornia;

  const isFeatureEnabled = Boolean(featureFlags?.[FeatureFlag.CHECKOUT_SELECT_SAVE_CARD_BY_DEFAULT]);

  return {
    isDefaultSaveCardAllowedForLocation: isFeatureEnabled && isDefaultSaveCardAllowedForLocation,
  };
}
